import { Component, OnInit, OnDestroy} from '@angular/core';
import { UtilityServiceService } from 'app/services/utility-service.service';
import { ToastrService } from 'ngx-toastr';
import { StorageService } from 'app/services/storage.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-calendar-viewer',
  templateUrl: './calendar-viewer.component.html',
  styleUrls: ['./calendar-viewer.component.css']
})
export class CalendarViewerComponent implements OnInit, OnDestroy {
  form: FormGroup;
  FDay: number = 0;
  LDate: number = 0;
  CDate: Date;
  CMonthName: string;
  CYear: number = 0;
  CWeekDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  CRows:any = [];
  CCols: any = [];
  CCell: number = 1;
  CDayNum: number = 1;
  innerHTML: any = null;
  CInnerHTML: any = null;
  CDays: any = null;
  compliance: any = null;
  isLoading: boolean = false;
  model: any = [];


  
  constructor(private utility: UtilityServiceService, private session: StorageService, private notice: ToastrService, private router: Router,private formBuilder: FormBuilder,) {
    
  }
  

  ngOnInit() {           
    this.compliance = this.session.getCompliance();
    //console.log('Compliance = ', this.compliance);
    this.model.justification = "This is a sample justification Text";
    this.model.declaration = "This is a sample declaration Text";
    this.initForm();
    this.initCalendar();

    
    
  }

  initForm() {
    this.form = this.formBuilder.group({
      nilreturnjustification: ['', []],
      nilreturndeclaration:['', []]
    });
  }
  ngOnDestroy() {    
    this.session.clearCompliance();
  }
  

  //Calendar features
  initTime = ()=> {
    // initialize time-related variables with current time settings
    let now = new Date();
    let hour = now.getHours();
    let minute = now.getMinutes();
    now = null;
    let ampm = "";

    // validate hour values and set value of ampm
    if (hour >= 12) {
      hour -= 12;
      ampm = "PM";
    } else
      ampm = "AM";
    hour = (hour == 0) ? 12 : hour;

    // add zero digit to a one digit minute
    if (minute < 10)
      minute = 0 + minute; // do not parse this number!

    // return time string
    return hour + ":" + minute + " " + ampm;
  }

  isLeapYear =(year)=> {
  if (year % 4 == 0) // basic rule
    return true // is leap year
  /* else */ // else not needed when statement is "return"
  return false // is not leap year
  }

monthDays=(month, year)=> {
  // create array to hold number of days in each month
  const monthDays = [31, (this.isLeapYear(year)) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  // return number of days in the specified month (parameter)
  return monthDays[month]
}

monthName =(month)=> {
  // create array to hold name of each month
  const monthNames =
    [
      "January", "February", "March", "April", "May", "June", "July",
      "August", "September", "October", "November", "December"
    ];

  // return name of specified month (parameter)
  return monthNames[month];
  }


initCalendar() {
  // standard time attributes
  let now = new Date();
  let year = now.getFullYear();//now.getYear()
  if (year < 1000)
    year += 1900
  let month = now.getMonth()
  let monthName = this.monthName(month)
  let date = now.getDate()
  now = null
  this.CYear = year;
  this.CMonthName = monthName;
  // create instance of first day of month, and extract the day on which it occurs
  let firstDayInstance = new Date(year, month, 1)
  let firstDay = firstDayInstance.getDay()
  firstDayInstance = null
  //console.log('First Day = ', firstDay);
  // number of days in current month
  let days = this.monthDays(month, year)
  const rows = Math.ceil((days + firstDay-1) / 7);
  this.CRows = Array(rows).fill(0);
  this.CCols = Array(7).fill(7);
  this.LDate = days;
  this.FDay = firstDay;

  // call function to draw calendar
 // this.processCal(firstDay, days, date, rows, 7);
  //this.processCal1(firstDay + 1, days, date, monthName, year);
  this.initCalendrier(firstDay, days, date, rows, 7,month+1,year);
}

processCal1=(firstDay, lastDate, date, monthName, year)=>{
  // constant table settings
  var headerHeight = 50 // height of the table's header cell
  var border = 2 // 3D height of table's border
  var cellspacing = 4 // width of table's border
  var headerColor = "midnightblue" // color of table's header
  var headerSize = "+3" // size of tables header font
  var colWidth = 60 // width of columns in table
  var dayCellHeight = 50 // height of cells containing days of the week
  var dayColor = "darkblue" // color of font representing week days
  var cellHeight = 40 // height of cells representing dates in the calendar
  var todayColor = "red" // color specifying today's date in the calendar
  var timeColor = "purple" // color of font representing current time

  // create basic table structure
  var text = "" // initialize accumulative variable to empty string
  text += '<CENTER>'
  text += '<TABLE BORDER=' + border + ' CELLSPACING=' + cellspacing + ' width="100%">' // table settings
  text += '<TH COLSPAN=7 HEIGHT=' + headerHeight + '>' // create table header cell
  text += '<FONT COLOR="' + headerColor + '" SIZE=' + headerSize + '>' // set font for table header
  text += monthName + ' ' + year
  text += '</FONT>' // close table header's font settings
  text += '</TH>' // close header cell

  // variables to hold constant settings
  var openCol = '<TD WIDTH=' + colWidth + ' HEIGHT=' + dayCellHeight + '>'
  openCol += '<FONT COLOR="' + dayColor + '">'
  var closeCol = '</FONT></TD>'

  // create array of abbreviated day names
  var weekDay = new Array(7)
  weekDay[0] = "Sun"
  weekDay[1] = "Mon"
  weekDay[2] = "Tues"
  weekDay[3] = "Wed"
  weekDay[4] = "Thu"
  weekDay[5] = "Fri"
  weekDay[6] = "Sat"

  // create first row of table to set column width and specify week day
  text += '<TR ALIGN="center" VALIGN="center">'
  for (var dayNum = 0; dayNum < 7; ++dayNum) {
    text += openCol + weekDay[dayNum] + closeCol
  }
  text += '</TR>'

  // declaration and initialization of two variables to help with tables
  var digit = 1
  var curCell = 1

  let calendar = "";

  for (var row = 1; row <= Math.ceil((lastDate + firstDay - 1) / 7); ++row) {
    calendar += '<TR ALIGN="right" VALIGN="top">'
    for (var col = 1; col <= 7; ++col) {
      if (digit > lastDate)
        break
      if (curCell < firstDay) {
        calendar += '<TD></TD>';
        curCell++
      } else {
        if (digit == date) { // current cell represent today's date
          calendar += '<TD HEIGHT=' + cellHeight + '>'
          calendar += '<FONT COLOR="' + todayColor + '">'
          calendar += digit
          calendar += '</FONT><BR>'
          calendar += '<FONT COLOR="' + timeColor + '" SIZE=2>'
          calendar += '<CENTER>' + this.initTime() + '</CENTER>'
          calendar += '</FONT>'
          calendar += '</TD>'
        } else
          calendar += '<TD HEIGHT=' + cellHeight + '>' + digit + '</TD>'
        digit++
      }
    }
    calendar += '</TR>'
  }

  // close all basic table tags
  text += calendar+ '</TABLE>'
  text += '</CENTER>'

  // print accumulative HTML string
  //document.write(text)
  this.CInnerHTML = calendar;
  this.innerHTML = text;
}

  increment = (counter, isMain = false) => {    
    if (isMain)
      this.CCell++;
    else
      this.CDayNum++;
    //console.log('Counter = ', counter);
    //return counter;
  }

  increm = (i,j) => {
       return this.CDays[i][j].day;
  }

  //processCal = (firstDay, lastDate, date, rows, cols=7) => {
   
  //  // declaration and initialization of two variables to help with tables
  //  let digit = 1
  //  let curCell = 1
  //  let calendar = "";

  //  for (let row = 1; row <= Math.ceil((lastDate + firstDay - 1) / 7); ++row) {
  //    calendar += '<tr ALIGN="right" VALIGN="top">'
  //    for (let col = 1; col <= 7; ++col) {
  //      if (digit > lastDate) {
  //        calendar += `<td bgcolor="ghostwhite"></td>`;
  //        this.CDays.push({ i: row - 1, j: col - 1, day: '' });
  //        break;
  //      }         
  //      if (curCell < firstDay) {
  //        calendar += `<td bgcolor="ghostwhite"></td>`;
  //        curCell++;
  //        this.CDays.push({ i: row - 1, j: col - 1, day: '' });
  //      } else {          
  //        let signal = (digit == date) ? "col-12 text-danger" : "col-12";
  //        this.CDays.push({ i: row - 1, j: col - 1, day: digit });
  //          calendar += `<td height="150px">
  //            <div class="row">
  //            <div class="${signal}">${digit }</div>
  //            <div class="col-12">
                
  //            </div>
  //            </div>            
  //         </td>`
  //        digit++
  //      }
  //    }
  //    calendar += '</tr>'
  //  }
  //  this.CInnerHTML = calendar;

   
  //  //console.log('Content : ', this.CDays);
  //  let days = null;
  //  let arr = Array.from(Array(rows), () => new Array(cols));
  //  this.CDays.map(row => {      
  //    arr[row.i][row.j] = row.day;
  //  });
    
  //  this.CDays = arr;
  //  //console.log('Row : ', this.CDays);
    
    
  //}


  initCalendrier = (firstDay, lastDate, date, rows, cols = 7,month,year) => {   
    let digit = 1
    let curCell = 1
    const monthC = (month < 10) ? `0${month}`:month;

    this.CDays = Array.from(Array(rows), () => new Array(cols));
    for (let row = 1; row <= Math.ceil((lastDate + firstDay - 1) / 7); ++row) {
      
      for (let col = 1; col <= 7; ++col) {
        if (digit > lastDate) {         
          this.CDays[row-1][col-1]={day: '' ,today:false};
          break;
        }
        if (curCell < firstDay) {         
          curCell++;
          this.CDays[row - 1][col - 1] = { day: '', today: false };
        } else {
          let signal = (digit == date) ? true : false;
          const dayC = (digit < 10) ? `0${digit}` : digit;
          this.CDays[row - 1][col - 1] = { day: digit, today: signal, cal_date: `${year}-${monthC}-${dayC}`,compliance:this.compliance };
          digit++
        }
      }
      
    }      
    //console.log('Content : ', this.CDays);    

   
  }

  isToday = (i, j) => {
    return this.CDays[i][j].today;
  }

  back = () => {

  }

  onBack() {    
    this.router.navigate([this.compliance.url]);
  }

  changeState = (event) => {

  }

}
